export const branches = [
  {
    id: 1,
    name: 'WHOLESALE & HEAD OFFICE',
    location: 'NICO CENTRE BUILDING, SHOP #8',
    address: 'GAME CAR PARK, OLD TOWN LILONGWE',
    city: 'Lilongwe',
    phone: ['+265 1 750 616'],
    whatsapp: '2651750616',
    enabled: true, // Only this branch is enabled
    hasDelivery: true,
    hasWhatsApp: true
  },
  {
    id: 2,
    name: 'RETAIL LILONGWE',
    location: 'NICO CENTRE BUILDING',
    address: 'GAME CAR PARK, OLD TOWN LILONGWE',
    city: 'Lilongwe',
    phone: ['+265 1 750 616'],
    whatsapp: '2651750616',
    enabled: true, // Retail Lilongwe is now enabled
    hasDelivery: true,
    hasWhatsApp: true
  },
  {
    id: 3,
    name: 'BLANTYRE BRANCH',
    location: 'ANADKAT HOUSE',
    address: 'OPPOSITE CHIBISA HOUSE, ALONG SIR GLYN JONES ROAD',
    city: 'Blantyre',
    phone: ['+265 01 820 001', '+265 0997 603 953'],
    whatsapp: '265997603953',
    enabled: false,
    hasDelivery: false,
    hasWhatsApp: false
  },
  {
    id: 4,
    name: 'LIMBE BRANCH',
    location: 'ILLOVOVO ROUNDABOUT',
    address: 'OPPOSITE PUMA FILLING STATION',
    city: 'Limbe',
    phone: ['+265 0999 266 883'],
    whatsapp: '265999266883',
    enabled: false,
    hasDelivery: false,
    hasWhatsApp: false
  },
  {
    id: 5,
    name: 'MZUZU BRANCH',
    location: 'OPPOSITE CONTINENTAL BAKERY',
    address: '',
    city: 'Mzuzu',
    phone: ['+265 991 580 240', '+265 1312 993'],
    whatsapp: '265991580240',
    enabled: false,
    hasDelivery: false,
    hasWhatsApp: false
  },
  {
    id: 6,
    name: 'SALIMA BRANCH',
    location: 'OFF KAMUZU ROAD',
    address: '',
    city: 'Salima',
    phone: ['+265 994 339 731'],
    whatsapp: '265994339731',
    enabled: false,
    hasDelivery: false,
    hasWhatsApp: false
  },
  {
    id: 7,
    name: 'MANGOCHI BRANCH',
    location: 'MAIN ROUNDABOUT, OFF CHILIPA ROAD',
    address: 'ADJACENT TO AHAD SHOP',
    city: 'Mangochi',
    phone: ['+265 994 439 536', '+265 882 693 236'],
    whatsapp: '265994439536',
    enabled: false,
    hasDelivery: false,
    hasWhatsApp: false
  }
];

// Get selected branch from localStorage or default to Lilongwe
export const getSelectedBranch = () => {
  const savedBranch = localStorage.getItem('selectedBranch');
  const currentBranches = getUpdatedBranches();
  
  if (savedBranch) {
    return currentBranches.find(b => b.id === parseInt(savedBranch)) || currentBranches[0];
  }
  return currentBranches[0]; // Default to Lilongwe (WHOLESALE & HEAD OFFICE)
};

// Save selected branch to localStorage
export const setSelectedBranch = (branchId) => {
  localStorage.setItem('selectedBranch', branchId.toString());
};

// Generate WhatsApp inquiry link
export const generateWhatsAppLink = (productName, branchWhatsApp) => {
  const message = `Hello, I would like to inquire about: ${productName}`;
  return `https://wa.me/${branchWhatsApp}?text=${encodeURIComponent(message)}`;
};

// Update branch data (for admin use)
export const updateBranch = (branchId, updates) => {
  const branchIndex = branches.findIndex(b => b.id === branchId);
  if (branchIndex !== -1) {
    branches[branchIndex] = { ...branches[branchIndex], ...updates };
    // Save to localStorage for persistence
    localStorage.setItem('updated_branches', JSON.stringify(branches));
  }
};

// Add new branch (for admin use)
export const addBranch = (newBranch) => {
  const updatedBranches = [...branches, newBranch];
  localStorage.setItem('updated_branches', JSON.stringify(updatedBranches));
  return updatedBranches;
};

// Get updated branches (checks localStorage first)
export const getUpdatedBranches = () => {
  const savedBranches = localStorage.getItem('updated_branches');
  if (savedBranches) {
    return JSON.parse(savedBranches);
  }
  return branches;
};


